import { ProductsImageType } from 'api/repositories/Products/Products';

export const ADD_TO_SHOP_CART = 'ADD_TO_SHOP_CART';
export const UPDATE_CART_SHOP = 'UPDATE_CART_SHOP';
export const CHANGE_PRODUCT_QUANTITY = 'CHANGE_PRODUCT_QUANTITY';
export const REMOVE_ITEM_FROM_SHOP_CART = 'REMOVE_ITEM_FROM_SHOP_CART';
export const ADD_PROMOTIONAL_SET = 'ADD_PROMOTIONAL_SET';

export const CARTS_POST_REQUEST = 'CARTS_POST_REQUEST';
export const CARTS_POST_SUCCEEDED = 'CARTS_POST_SUCCEEDED';
export const CARTS_POST_FAILED = 'CARTS_POST_FAILED';

export const CART_ITEMS_POST_REQUEST = 'CART_ITEMS_POST_REQUEST';
export const CART_ITEMS_POST_SUCCEEDED = 'CART_ITEMS_POST_SUCCEEDED';
export const CART_ITEMS_POST_FAILED = 'CART_ITEMS_POST_FAILED';

export const CART_ITEM_DELETE_REQUEST = 'CART_ITEM_DELETE_REQUEST';
export const CART_ITEM_DELETE_SUCCEEDED = 'CART_ITEM_DELETE_SUCCEEDED';
export const CART_ITEM_DELETE_FAILED = 'CART_ITEM_DELETE_FAILED';

export const CART_ITEM_QUANTITY_REQUEST = 'CART_ITEM_QUANTITY_REQUEST';
export const CART_ITEM_QUANTITY_SUCCEEDED = 'CART_ITEM_QUANTITY_SUCCEEDED';
export const CART_ITEM_QUANTITY_FAILED = 'CART_ITEM_QUANTITY_FAILED';

export const FETCH_CART_REQUEST = 'FETCH_CART_REQUEST';
export const FETCH_CART_SUCCEEDED = 'FETCH_CART_SUCCEEDED';
export const FETCH_CART_FAILED = 'FETCH_CART_FAILED';

export const CART_PROMOTIONAL_SET_REQUEST = 'CART_PROMOTIONAL_SET_REQUEST';
export const CART_PROMOTIONAL_SET_SUCCEEDED = 'CART_PROMOTIONAL_SET_SUCCEEDED';
export const CART_PROMOTIONAL_SET_FAILED = 'CART_PROMOTIONAL_SET_FAILED';

export type ShopCartItem = {
    code: string;
    quantity: number;
    details: {
        id?: number;
        name: string;
        type: string;
        slug: string;
        price?: number;
        images: ProductsImageType;
        products?: Array<any>;
        minQuantity: number;
    };
};

export type ItemsInShopAmountType = {
    [key: string]: number;
};

export type CartShopStats = {
    amount: number;
    sumPrice: number;
};
